import HomeAbout from "../components/home/HomeAbout";
import HomeCTASection from "../components/home/HomeCTASection";
import HomeGalleryShow from "../components/home/HomeGalleryShow";
import HomeHero from "../components/home/HomeHero";
import HomeServices from "../components/home/HomeServices";
import HomeTestimonials from "../components/home/HomeTestimonials";
import HomeWhy from "../components/home/HomeWhy";
import HowWeWork from "../components/home/HowWeWork";

export default function Home() {
  return (
    <>
      <HomeHero />
      <HomeAbout />
      <HomeServices />
      <HomeWhy />
      <HowWeWork />
      <HomeGalleryShow />
      <HomeTestimonials />
      <HomeCTASection />
    </>
  );
}
